module.exports = __webpack_public_path__ + "img/icon-right.0b8eccac.svg";